import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from "@/components/ui/collapsible";
import { ImprovementProposal } from "@/schema/improvement-proposal/ImprovementProposal";
import {
  ChevronDown20Regular,
  ChevronUp20Regular,
  TextBulletListSquareEdit20Regular,
} from "@fluentui/react-icons";
import { useState } from "react";
import { useController, useFieldArray, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import EvaluationRow from "./EvaluationRow";

interface CollapsibleSubcategoryProps {
  index: number;
}

function CollapsibleSubcategory({ index }: CollapsibleSubcategoryProps) {
  const [isOpen, setIsOpen] = useState(true);
  const { control } = useFormContext<ImprovementProposal>();
  const { t } = useTranslation();

  const {
    field: {
      value: { content, sub_category_results },
    },
  } = useController({
    control,
    name: `main_category_results.${index}`,
  });

  const { fields } = useFieldArray({
    control,
    name: `main_category_results.${index}.sub_category_results`,
    keyName: "key",
  });

  const CollapseIndicatorArrow = isOpen ? (
    <ChevronUp20Regular color="#6B7280" />
  ) : (
    <ChevronDown20Regular color="#6B7280" />
  );

  if (fields.length === 0) return null;

  return (
    <Collapsible open={isOpen} onOpenChange={setIsOpen}>
      <CollapsibleTrigger asChild>
        <div className=" flex flex-row items-center justify-between bg-cool-gray-100 hover:bg-cool-gray-200 transition-colors duration-300 py-2 px-3 cursor-pointer border-t border-cool-gray-200">
          <div className=" flex flex-row space-x-3 items-center">
            <TextBulletListSquareEdit20Regular />
            <p className=" text-sm font-medium text-cool-gray-900">{content}</p>
          </div>
          <div className=" flex flex-row space-x-4 items-center">
            <p className=" text-xs font-medium text-cool-gray-500">
              {sub_category_results.length} {t("sub-categories")}
            </p>
            {CollapseIndicatorArrow}
          </div>
        </div>
      </CollapsibleTrigger>
      <CollapsibleContent>
        {fields.map((field, subCategoryIndex) => (
          <EvaluationRow
            key={field.key}
            categoryIndex={index}
            subCategoryIndex={subCategoryIndex}
          />
        ))}
      </CollapsibleContent>
    </Collapsible>
  );
}

export default CollapsibleSubcategory;
